const CrifRequestType =  {
    REPORT: 1,
    ADDRESS_INVESTIGATION: 2,
    1: "Rapport",
    2: "Enquête sur les adresses"
};

export default CrifRequestType;